import UploadingFile from './container';

export default UploadingFile;
